<sim-basic-material-dialog
	(closeClicked)="
		close({
			uploadedFiles: uploadedFiles,
			action: 'ok',
		})
	"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-image-polaroid', fontSet: 'fad'}"
	[headerText]="T.EVENT_CREATION_ATTACHMENT_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<input #uploadInput (change)="handleFileInput($event)" id="upload" multiple style="display: none" type="file" />

		@if (currentSelectedFiles && currentSelectedFiles?.length !== 0) {
			<div class="previewText">
				{{ T.ASSESSMENT_EDIT_PREVIEW | translate }}
			</div>
		}

		@if (currentSelectedFiles && currentSelectedFiles?.length !== 0) {
			<div class="previewFiles">
				<div class="filePreviewList">
					@for (currentSelectedFile of currentSelectedFiles; track currentSelectedFile; let i = $index) {
						<div [@anim]="'active'" class="previewFile">
							<sim-media-card-list
								(deleteButtonClicked)="deleteFromSelection(i)"
								(mediaNameChange)="currentSelectedFile.newName = $event"
								[active]="currentSelectedFile?.isPlaying"
								[currentSelectedFile]="currentSelectedFile"
								[errorMessage]="currentSelectedFile.errorMessage"
								[isUploading]="currentSelectedFile.isUploading"
								[mediaName]="currentSelectedFile.name"
								[previewMediaUrl]="currentSelectedFile.mediaUrl.toString()"
								[previewMedia]="true"
								[progress]="currentSelectedFile?.progress"
								[showDeleteButton]="true"
								[uploadProgress]="currentSelectedFile.progressUploading"
							/>
						</div>
					}
				</div>
			</div>
		}

		<div class="uploadFilesFirst">
			<div class="uploadBtnns">
				<button
					(click)="chooseFiles()"
					[color]="currentSelectedFiles && currentSelectedFiles.length !== 0 ? 'warn' : 'accent'"
					class="uploadBtn"
					mat-raised-button
				>
					{{
						currentSelectedFiles && currentSelectedFiles.length !== 0
							? (T.UPLOAD_ATTACHMENT_DIALOG_CLEAR_SELECTION | translate)
							: (T.UPLOAD_ATTACHMENT_DIALOG_CHOOS_FILES_FOR_UPLOAD | translate)
					}}
				</button>

				<button
					(click)="uploadFiles()"
					[disabled]="!currentSelectedFiles || currentSelectedFiles?.length === 0"
					class="uploadToSimStation"
					color="accent"
					mat-raised-button
				>
					{{ T.UPLOAD_MEDIA_DIALOG_BUTTON | translate }}
				</button>
			</div>

			@if (afterViewInit && !currentSelectedFiles) {
				<div [@zoomInOnEnter] [@zoomOutOnLeave] class="uploadHint">
					{{ T.EVENT_CREATION_ATTACHMENTS_SELECTION_HINT | translate }}
					<br />
				</div>
			}
		</div>
	</ng-container>
</sim-basic-material-dialog>
